var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"pa-1 ma-1",attrs:{"dense":"","text":"","type":"info","dismissible":""},model:{value:(_vm.warningZone),callback:function ($$v) {_vm.warningZone=$$v},expression:"warningZone"}},[_vm._v(" Внимание! Мы заметили отсутствие активности в системе. Через минуту произойдет автоматическое отключение. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }